/** Le cifre di chi amministra, dal lato della pagina (GI-227). */
import { get } from './api'

export type Period = 'week' | 'month' | 'all'

export const PERIODS: Period[] = ['week', 'month', 'all']

export interface Package {
  inspection_id: string
  external_inspection_id: number
}

export interface StageCount {
  stage: string
  count: number
  packages: Package[]
}

export interface LevelCount {
  level: number
  count: number
}

export interface Deliveries {
  submitted: number
  with_receipt: number
  accepted: number
  rejected: number
  packages: Package[]
}

export interface Overview {
  period: Period
  since: string | null
  computed_at: string
  packages: StageCount[]
  findings: LevelCount[]
  findings_total: number
  awaiting_gate: number
  deliveries: Deliveries
}

export function readOverview(period: Period): Promise<Overview> {
  return get<Overview>(`/overview?period=${period}`)
}
